import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { WeatherProvider } from "./context/weatherContext";
import { TasksProvider } from "./context/TasksProvider";
import {Provider} from "react-redux"
import { store } from "./app/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
       
          <WeatherProvider>
            <TasksProvider>
              <Provider store={store}>

              <div id="root-modal" />
              <App />
              </Provider>
            </TasksProvider>
          </WeatherProvider>
        
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
